export default {
    data: function () {
        return {
            modal: false
        }
    },
    methods: {
        openModal(modal) {
            this.modal = modal
            return true
        },
        closeModal(modal) {
            this.modal = false
            document.body.classList.remove('modal-open')
            document.body.style.overflow = ''
            document.body.style.paddingRight = ''
            return true
        },
        isModalOpen(modal) {
            return this.modal === modal
        }
    }
}
